import { getLatestDisplayVersions, getVersionsByApp, } from '@wix/ambassador-devcenter-versions-v1-versions-response/http';
import { VersionStatus, } from '@wix/ambassador-devcenter-versions-v1-versions-response/types';
import { HttpClient } from '@wix/http-client';
const httpClient = new HttpClient();
export const getLastPublishedDate = async ({ appId, }) => {
    const { data } = await httpClient.request(getVersionsByApp({
        appId,
    }));
    const lastPublishedDate = data.versions?.filter((version) => version.status === VersionStatus.ARCHIVED)[0]?.dateUpdated;
    return lastPublishedDate;
};
export const getHasVersionToSubmit = async ({ appId, }) => {
    const { data } = await httpClient.request(getLatestDisplayVersions({
        appId,
    }));
    const versionNames = data.displayVersions?.map((version) => {
        return version.displayName;
    });
    const lastVersionName = versionNames?.sort().reverse()[0];
    const lastVersion = data.displayVersions?.find((version) => {
        return version.displayName === lastVersionName;
    });
    const hasVersionToSubmit = lastVersion?.status !== VersionStatus.SUBMITTED &&
        lastVersion?.status !== VersionStatus.IN_REVIEW &&
        lastVersion?.status !== VersionStatus.APPROVED;
    return hasVersionToSubmit;
};
//# sourceMappingURL=versionsService.js.map